import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=7cfd9d4c&scoped=true"
import script from "./shoplist.vue?vue&type=script&lang=js"
export * from "./shoplist.vue?vue&type=script&lang=js"
import style0 from "./shoplist.vue?vue&type=style&index=0&id=7cfd9d4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd9d4c",
  null
  
)

export default component.exports